/*
 * @Author: your name
 * @Date: 2020-09-14 10:30:00
 * @LastEditTime: 2020-10-27 12:57:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\pages\home\manages\ContactUsImpl.ts
 */
import { ContactUsService } from '../services/HomeService'
import { ContactUs } from '../models/ContactUs'
import { ContactUsManage } from '../interfaces/ContactUs'
class ContactUsImpl implements ContactUsManage {
  ContactUsData: ContactUs = new ContactUs('', '', '', '', '')
  service: ContactUsService
  // loading: boolean = false
  constructor (service: ContactUsService) {
    this.service = service
  }

  public async requestContactUsData () {
    if (localStorage.getItem('contactUsInfo')) {
      this.ContactUsData = JSON.parse(localStorage.getItem('contactUsInfo') as any)
    }
    const res = await this.service.getContactUsService()
    localStorage.setItem('contactUsInfo', JSON.stringify(res))
    Object.keys(res).map((key: string) => {
      if (res[key] !== this.ContactUsData[key]) {
        this.ContactUsData[key] = res[key]
      }
    })
  }
}
export { ContactUsImpl }
